import { app } from '../../../../../app';
import { Controller } from './developers.controller';

app.component('companySaaspassConnectManageDevelopers', {
    bindings: {
        companyId: '<',
        connectId: '<',
    },
    controller: Controller,
    templateUrl: require('./developers.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/developers/developers.component.js